export default "__VITE_ASSET__Bn9Dare2__"